import type { LucideIcon } from "lucide-react";
import { Button, type ButtonProps } from "./button";
import { cn } from "./lib/cn";

export interface IconButtonProps extends Omit<ButtonProps, "children" | "aria-label"> {
  icon: LucideIcon;
  label: string;
}

export function IconButton({ icon: Icon, label, className, ...props }: IconButtonProps) {
  return (
    <Button
      aria-label={label}
      title={label}
      className={cn("size-11 min-h-11 shrink-0 px-0", className)}
      {...props}
    >
      <Icon aria-hidden="true" className="size-5" strokeWidth={2} />
    </Button>
  );
}
